export default __webpack_public_path__ + "static/media/Login-Best-Pizza.ebd7e7bc.png";